import { render, staticRenderFns } from "./ClientViewSidebarHistory.vue?vue&type=template&id=386692c7&scoped=true"
import script from "./ClientViewSidebarHistory.vue?vue&type=script&lang=ts"
export * from "./ClientViewSidebarHistory.vue?vue&type=script&lang=ts"
import style0 from "./ClientViewSidebarHistory.vue?vue&type=style&index=0&id=386692c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386692c7",
  null
  
)

export default component.exports